import { Loading } from 'element-ui'
export default {
  data() {
    return {
      filterForm: {}, // 筛选数据
      tableData: [], // 表格数据
      tableDataCopy: [], // 表格数据
      selectRows: [], // 表格选中行数据
      selectData: {}, // 表格选中行编辑数据
      // areaIdsChecked: [], // 表格选中行编辑地区数据 => 替换筛选地区数据

      isCreate: false,

      btnShow: {
        search: false,
        create: false,
        modify: false,
        delete: false,
        import: false,
        export: false,
        migration: false,
      }, // 权限显隐
      
      pageData: {
        currentPage: 1,
        pageSize: 40,
        total: 0,
      }, // 页码数据

      //  导入 与 下载 
      importFiles: [],
      isShowImportTip: false,
      loadingInstance: '',
      importResult: '',
    }
  },
  computed: {
    areaPickerRef() {
      let result = this.$refs.AreaPicker
      if (!result) {
        // 兼容新版FilterBox组件
        const domFilterBox = this.$refs.FilterBox
        if (!domFilterBox) return null
        result = domFilterBox.$refs.AreaPicker
        if (Array.isArray(result)) return result[0]
        return result
      }
      if (Array.isArray(result)) return result[0]
      return result
    },
    tableRef() {
      let result = this.$refs.TableRef
      if (!result) {
        // 兼容新版TableBox组件
        const domTableBox = this.$refs.TableBox
        if (!domTableBox) return null
        result = domTableBox.$refs.TableRef
        if (Array.isArray(result)) return result[0]
        return result
      }
      if (Array.isArray(result)) return result[0]
      return result
    },
  },
  methods: {
    // #region 导入与下载
    // 导入前
    beforeImport(file) {
      console.log(file)
      this.loadingInstance = Loading.service({
        lock: true,
        text: '导入中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
        fullscreen: true 
      })
    },
    // 导入成功
    importSuccess(response, file, fileList) {
      console.log(`%cresponse:`, 'color: #f00;', response)
      this.$nextTick(() => {
        this.loadingInstance.close()
      }) // 以服务的方式调用的 Loading 需要异步关闭
      switch (response.status) {
        case 0:
          if (response.data) {
            // this._tips({message:'上传成功'})
            let result = JSON.parse(response.data)
            console.log(result)
            let failDataList = JSON.parse(result.failedResult)
            console.log(failDataList)
            console.log(`%c上传结果:`, 'color: #00f;', result)
            let failStr = ''
            if (result.failedCount !== 0) {
              console.log(`%c失败列表:`, 'color: #00f;', failDataList)
              failStr = `
                <p style="height:30px;line-height:30px;">导入失败 <strong style="color:red;">${result.failedCount}</strong> 条</p>
                <p style="margin-left:40px;height:30px;line-height:30px;">
                  <span>错误原因</span>
                  <span style="float:right;">错误数据</span>
                </p>
              `

              failDataList.forEach(x => {
                failStr += `
                  <div style="margin-left:40px;line-height:24px;border-top:1px solid #eee;">
                    <p>${x.error}</p>
                    <p style="text-align:right;">${this.importTiplabel}：<strong style="color:red;">${x[this.importTipKey]}</strong></p>
                  </div>
                `
              })
              // console.log(failDataList);
              
              // failStr += ' </p><p style="color:red;">* 可能造成的原因：地区错误 *</p>'
            }
            // if (result.duplicateCount !== 0) {
            //    failStr += '<p style="margin-left:20px;">重复数据 <strong style="color:red;">'+result.duplicateCount+'</strong> 条</p>'
            // }
            this.importResult = `<p style="height:30px;line-height:30px;">导入成功 <strong style="color:green;">${result.successCount+result.duplicateCount}</strong> 条</p>${failStr}`
            // this.$alert(code, '上传结果', { dangerouslyUseHTMLString: true })
            this.isShowImportTip = true
            this.importFiles = []
            this.filterHandler()
          } else {
            this.importResult = `<p style="height:30px;line-height:30px;">导入成功！</p>`
            this.isShowImportTip = true
            this.importFiles = []
            this.filterHandler()
          }
          break;
        case 1: this.$message.error('用户已被冻结'); break;
        case 2: this.$message.error('用户不存在'); break;
        case 3: this.$message.error('用户名或者密码错误'); break;
        case 4: this.$message.error('用户未登录'); break;
        case 5: this.$message.error('目录名已存在'); break;
        case 6: this.$message.error('不是管理员'); break;
        case 7: this.$message.error('系统错误'); break;
        case 8: this.$message.error('名称已存在'); break;
        case 9: this.$message.error('分站管理员已经存在'); break;
        case 10: this.$message.error('权限不够'); break;
        case 11: this.$message.error('权限不够'); break;
        case 12: this.$message.error('模板已过期'); break;
        case 36: case 37:
          this.$message.error('没有配置相关字段')
          this.isShowSetkeyword = true
          this.importFiles = []
          break;
      }
    },
    beforeSearchAndExportHandler(obj) {
      let rD = {}
      let keys = Object.keys(obj)
      if (keys.length > 0) {
        keys.forEach(x => {
          switch (typeof obj[x]) {
            case 'string':
            case 'number':
              obj[x] !== '' ? rD[x] = obj[x] : ''
              break;
            case 'object':
              for (const key in obj[x]) {
                // console.log(key)
                if (obj[x].hasOwnProperty(key)) {
                  const value = obj[x][key]
                  // console.log(value)
                  if (value) {
                    if (typeof rD[x] !== 'object') {
                      rD[x] = {}
                    }
                    rD[x][key] = obj[x][key]
                  }
                }
              }
              break;
          }
        })
      }
      return rD
    },
    // 导出
    exportHandler(areaId) {
      areaId ? '' : areaId = this.areaPickerRef.findAreaId()
      console.log(`%cfilterForm:`, 'color: #00f;', this.filterForm)
      let rD = this.beforeSearchAndExportHandler(this.filterForm)

      if (areaId) {
        let loadingInstance = Loading.service({
          lock: true,
          text: '导出中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)',
          fullscreen: true 
        })
        rD.areaId = areaId
        this.$api.util_export(this.sign, rD).then(res => {
          if (res.data.status == 0) {
            let _R = res.data.data
            this.downloadFun(_R)
            this.$nextTick(() => { loadingInstance.close() })
          } else {
            this._status(res.data)
            this.$nextTick(() => { loadingInstance.close() })
          }
        })
      } else { this.$message.warning('请选择地区！') }
    },
    // 下载方法
    downloadFun(id) {
      var a = document.createElement('a')
      a.style.display = 'none'
      a.href = `${this.$api.baseUrl}/user/download/${id}`
      a.download = true
      // a.target = '_blank'
      document.body.appendChild(a)
      a.click()
    },
    // 下载模板
    downloadHandler() {
      var a = document.createElement('a')
      a.style.display = 'none'
      a.href = `/xls/${this.fileName}.xls`
      a.download = `${this.fileName}.xls`
      // a.target = '_blank'
      document.body.appendChild(a)
      a.click()
    },
    // #endregion
    // 分页
    pageChange(pageNumer) {
      console.log(`%c调用了点击页码`, 'color: #f00;', )
      this.pageData.currentPage = pageNumer
      this.filterForm.pageNumber = pageNumer
      this.searchHandler()
    },
    // #region 基础
    // #region 筛选区
    // 筛选
    filterHandler(areaId) {
      console.log(`%c调用了筛选`, 'color: #f00;', areaId)
      this.pageData.currentPage = 1
      this.searchHandlerBefore ? this.searchHandlerBefore() : ''
      this.searchHandler(areaId)
    },
    // 查询
    async searchHandler(areaId) {
      console.log(`%c调用了查询`, 'color: #f00;', areaId)
      console.log(`%c调用了查询`, 'color: #f00;', this.$refs)
      areaId ? '' : areaId = this.areaPickerRef.findAreaId()
      let rD = this.beforeSearchAndExportHandler(this.filterForm)

      if (!areaId && !this.searchCanEmpty) {
        this.$message.warning('请选择地区！')
        return
      }
      if (areaId) {
        rD.areaId = areaId
        rD.pageNumber = this.pageData.currentPage
      } else if (this.searchCanEmpty) {
        rD.pageNumber = this.pageData.currentPage
      }
      // console.log(rD)
      await this.getData(rD)
      this.tableData.forEach(x1 => {
        x1['fixed-area'] = x1.province + x1.city + x1.county + x1.town + x1.village
      })
      this.selectRows = []
      this.selectData = {}
    },
    resetHandler() {
      this.filterForm = this.filterForm_ori ? JSON.parse(JSON.stringify(this.filterForm_ori)) : {}
      if (this.areaPickerRef) {
        this.areaPickerRef.reset()
      }
    },
    // #endregion
    // #region 按钮区
    // 点击选中
    selectHandler(cRow, oRow) {
      // console.log(`%ccRow, oRow:`, 'color: #f00;', cRow, oRow)
      this.tableRef.clearSelection();
      this.tableRef.toggleRowSelection(cRow);
      this.selectData = JSON.parse(JSON.stringify(cRow))
    },
    // 勾选选中
    checkHandler(cRows) {
      // console.log(`%ccRows:`, 'color: #f00;', cRows)
      this.selectRows = JSON.parse(JSON.stringify(cRows))
      if (cRows.length === 1) {
        this.selectData = this.selectRows[0]
      }
    },
    // 删除
    deleteHandler() {
      console.log(`%c调用了删除`, 'color: #f00;', )
      let ids = this.selectRows.map(x => x.id)
      let rD = { ids }
      if (this.selectRows.length > 0) {
        this.$confirm('确认删除数据？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$api.util_delete(this.sign, rD).then(res => {
            if (res.data.status === 0 ) {
              this.$message.success('删除成功！')
              // —————————————————— 把当前页的所有数据都删除时，需要更换页码 s ——————————————————
              let nowtotal = this.pageData.total - ids.length
              if (nowtotal % this.pageData.pageSize === 0) {
                if (this.pageData.currentPage > 1) {
                  this.pageData.currentPage--
                } else {
                  this.pageData.currentPage = 1
                }
              }
              // —————————————————— 把当前页的所有数据都删除时，需要更换页码 e ——————————————————
              console.log('删除后总条数',nowtotal,'当前页数',this.pageData.currentPage)
              this.searchHandler()
            } else { this._status(res.data) }
          })
        }).catch(() => {})
      } else { this.$message.warning('请至少勾选一条数据！') }

    },
    // 打开弹框 查看
    viewHandler() {
      if (this.selectData) {
        // 如果对话框里有切换的项目，修改前要先切换到对应的项目
        if(this.watchChangeKey) {
          this.watchChangeKey.forEach(x => {
            this.watchChange({ key: x, val: this.selectData[x] })
          })
        }
  
        this.$refs.DialogView.viewHandler(this.selectData)
      }
    },
    // 打开弹框 修改
    modifyHandler() {
      if (this.selectData) {
        // 修改前的回调 如送站的身份证特殊处理
        this.modifyHandlerBefore ? this.modifyHandlerBefore() : ''

        this.isCreate = false
        // let { provinceId, cityId, countyId, townId, villageId } = this.selectData
        // let areaIds = [ provinceId, cityId, countyId, townId, villageId ]
        // this.areaIdsChecked = areaIds.filter(x => !!x)
        // console.log(areaIds, this.areaIdsChecked)
        
        // 如果对话框里有切换的项目，修改前要先切换到对应的项目
        if(this.watchChangeKey) {
          this.watchChangeKey.forEach(x => {
            this.watchChange({ key: x, val: this.selectData[x] })
          })
        }

        this.$refs.DialogEdit.modifyHandler(this.selectData)
      }
    },
    // 打开弹框 新建
    createHandler() {
      this.isCreate = true
      this.createHandlerBefore ? this.createHandlerBefore() : ''

      // 如果对话框里有切换的项目，修改前要先切换到对应的项目
      if(this.watchChangeKey) {
        this.watchChangeKey.forEach(x => {
          this.watchChange({ key: x, val: this.defaultKeyValue[x] })
        })
      }

      this.$refs.DialogEdit.createHandler()
    },
    // 提交弹框
    dialogSubmitCb(mapList, otherParams) {
      console.log(`%c调用了提交弹框`, 'color: #f00;', )
      let item = this.selectRows[0]
      let rD = {}
      mapList.forEach(x => {
        if (item[x] !== this.selectData[x]) {
          rD[x] = this.selectData[x]
        }
      })
      if (JSON.stringify(rD) !== '{}') {
        rD.id = item.id
        if (otherParams) {
          Object.assign(rD, otherParams)
        }
        console.log(`%cthis.selectData:`, 'color: #f00;', this.selectData, rD)
        this.$api.util_modify(this.sign, rD).then(res => {
          if (res.data.status == 0) {
            this.$message.success('成功！')
            this.searchHandler()
            // this.dialogClose()
          } else { this._status(res.data) }
        })
      } else {
        console.log(`%c没有改变`, 'color: #f0f;')
        // this.dialogClose()
      }
    },
    // #endregion
    // 获取表格数据
    getDataCb(rD = {}) {
      this.$api.util_search(this.sign, rD).then( res=> {
        if (res.data.status == 0) {
          let _R = JSON.parse(res.data.data)
          this.tableData = _R
          this.pageData.total = res.data.size
          console.log(`%c返回数据:`, 'color: #f00;', this.tableData)
        } else { this._status(res.data) }
      })
    },
    // #endregion
  },
}